export const takeScreengrab = function takeScreengrab() {
  const canvas = document.getElementById("x3dom-appScene-canvas");
  const image = new Image();
  image.src = canvas.toDataURL();

  return image;
};
